import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/jwt-auth",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const apiKeysApi = createApi({
  reducerPath: "apiKeysApi",
  baseQuery,
  endpoints: (builder) => ({
    getApiKey: builder.query({
      query: () => "/apikey",
    }),
    deleteApiKey: builder.mutation({
      query: ({ keyId }) => ({
        url: `/apikey/${keyId}`,
        method: "DELETE",
      }),
    }),
    postApiKey: builder.mutation({
      query: ({ expires_at, name, permissions }) => ({
        url: "/apikey",
        method: "POST",
        body: { expires_at, name, permissions },
      }),
    }),
    getApiKeys: builder.query({
      query: () => "/apikeys",
    }),
    deleteApiKeys: builder.mutation({
      query: ({ keyId }) => ({
        url: `/apikeys/${keyId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetApiKeyQuery,
  useGetApiKeysQuery,
  useDeleteApiKeyMutation,
  useDeleteApiKeysMutation,
  usePostApiKeyMutation,
} = apiKeysApi;
